import React, { Component } from 'react';
import {connect} from 'react-redux'
import { withRouter } from "react-router-dom";
import PortalLink from './PortalLink'
class Portal extends Component {
    render() {
        const role = this.props.role
        return <div className={`portal-container flex-column max-height`}>
            <nav className="flex-column" id='portal-navlinks-container'>

                {["Dev", "E&E", "Engineer","Work Lead", "Shop Supervisor"].includes(role) ? 
                <PortalLink portalName="Home" url="home"/> : null}
                
                
                

                {["Dev", "E&E", "Engineer"].includes(role) ? 
                <PortalLink portalName="Work Instructions" url="work instructions parent" /> : null }
                {["Artisan","Dev","E&E","Engineer","Work Lead", "Shop Supervisor"].includes(role) ? 
                    <PortalLink portalName="Instruction Viewer" url="model viewer" /> : null}                
                
                {/* 
                {["Dev", "Work Lead", "Shop Supervisor"].includes(role) ?
                <PortalLink portalName="Assignments"/> : null } */}
                
                {["Dev", "Work Lead", "Shop Supervisor","Artisan"].includes(role) ?
                    <PortalLink portalName="Feedback" url="feedback" /> : null}
                
                {["Dev", "Work Lead", "Shop Supervisor"].includes(role) ?
                <PortalLink portalName="Manage Users" url="management/users"/> : null }

                {/* {["Dev", "Work Lead", "Shop Supervisor"].includes(role) ?
                <PortalLink portalName="Manage Devices" url="management/devices"/> : null} */}

                {["Dev", "Engineer"].includes(role) ?
                    <PortalLink portalName="Model Uploader" url="model uploader"/> : null}
                
                {["Dev","E&E","Engineer","Work Lead", "Shop Supervisor"].includes(role) ? 
                    <PortalLink portalName="Attachment Library" url="Attachment Library" /> : null}    
                                




                
                <div id="faq-portal-link-container" className="flex portal-faq-bPadding">
                    <PortalLink portalName="FAQ" url="faq"/>
                </div>
            </nav>
        </div>
    }
}

const mapStateToProps = state => ({ role: state.session.user ? state.session.user.role : undefined });
export default withRouter(connect(mapStateToProps)(Portal))